<template>
    <div class="teaching-details-content">
        <div class="teaching-details-wrapper">
            <div class="teaching-details-middle">
                <div class="teaching-details-nav">
                    <p>
                        <span @click="toHome">首页</span> > <span @click="getBookCenter">教材中心</span> >
                        <span>{{ bookInfo.Title }}</span>
                    </p>
                </div>
                <div class="teaching-details-abstract">
                    <div class="details-abstract-top clearfix">
                        <div class="details-abstract-video fl">
                            <img :src="bookInfo.BookCover || abstractImg" alt class="video-img-cover" />
                        </div>
                        <div class="details-abstract-content fl">
                            <h3>
                                {{ bookInfo.Title }}
                                <span class="details-abstract-share fr">
                                    分享到：
                                    <a :href="shareLinkZone" target="_blank" @click="getShareLink">
                                        <i class="wl-icon-QQkongjian" style="color:#FFD042;border-color:#FFD042;"></i>
                                    </a>
                                    <a :href="shareLinkQq" target="_blank" @click="getShareLink">
                                        <i class="wl-icon-qq1" style="color:#1AB2FF;border-color:#1AB2FF;"></i>
                                    </a>
                                </span>
                            </h3>
                            <p class="details-abstract-message">
                                <span>
                                    <i class="wl-icon-chakan"></i>
                                    {{ bookInfo.ViewCount }}
                                </span>
                            </p>
                            <p class="details-abstract-text">教材简介：{{ bookInfo.TextBookBrief }}</p>
                            <div class="details-abstract-data clearfix">
                                <div class="details-data-left fl">
                                    <p>定 价：￥{{ bookInfo.Price }}</p>
                                    <p>作者：{{ bookInfo.Author }}</p>
                                    <p>教材编号(ISBN)：{{ bookInfo.ISBN }}</p>
                                    <p>发行日期：{{ bookInfo.IssueDate }}</p>
                                    <p>出版社：{{ bookInfo.publishName }}</p>
                                </div>
                                <div class="details-data-right fl">
                                    <div class="datails-data-right-img">
                                        <!-- <img :src="loginImg" alt /> -->
                                        <qrcode-vue :value="value" :size="115" level="H" />
                                    </div>
                                    <p>手机扫一扫，即可浏览</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="teaching-details-content clearfix">
                    <div class="teaching-content-tab fl">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="目录" name="catalo">
                                <div class="content-tab-catalo">
                                    <div class="content-tab-catalo-ul" v-for="(item, index) in BookCatalogData" :key="index">
                                        <div class="content-tab-catalo-li">
                                            <div class="content-tab-catalo-li-nav">
                                                <i class="wl-icon-zaixiankecheng"></i>
                                                <span v-if="NumType1 == '1'">{{ Level1.replace("\{\{index\}\}", index + 1) }}</span>
                                                <span v-if="NumType1 == '一'">{{ (index + 1) | priceFmt(Level1) }}</span>
                                                <span v-html="item.name">{{ item.name }}</span>
                                            </div>
                                        </div>
                                        <!-- 第二层 -->
                                        <div class="content-tab-catalo-lis">
                                            <div class="content-tab-catalo-lis-nav" v-for="(nav, index1) in item.topics" :key="index1">
                                                <h3>
                                                    <i class="wl-icon-dian"></i>
                                                    <span v-if="NumType2 == '1'">{{ Level2.replace("\{\{index\}\}", index1 + 1).replace("\{\{x\}\}", index + 1) }}</span>
                                                    <span v-if="NumType2 == '一'">{{ (index1 + 1) | priceFmt(Level2) }}</span>
                                                    <span v-html="nav.name">{{ nav.name }}</span>
                                                </h3>
                                                <div class="clearfix">
                                                    <div class="content-tab-catalo-list">
                                                        <div v-for="(name, index2) in nav.cells" :key="index2" class="content-tab-catalo-list-p" @click="gobook(name.Id, name.CellType)">
                                                            <i class="wl-icon-ziyuan content-tab-catalo-icon" v-if="name.CellType == 1"></i>
                                                            <i class="wl-icon-lianjie1 content-tab-catalo-icon" v-if="name.CellType == 2"></i>
                                                            <i class="wl-icon-tuwen1 content-tab-catalo-icon" v-if="name.CellType == 3"></i>
                                                            <i class="wl-icon-wenjianjia1 content-tab-catalo-icon" v-if="name.CellType == 4"></i>
                                                            <i class="wl-icon-ceyan1 content-tab-catalo-icon" v-if="name.CellType == 5"></i>
                                                            <i class="wl-icon-zuoye_huaban content-tab-catalo-icon" v-if="name.CellType == 6"></i>
                                                            <i class="wl-icon-toupiao content-tab-catalo-icon" v-if="name.CellType == 7"></i>
                                                            <i class="wl-icon-taolun2 content-tab-catalo-icon" v-if="name.CellType == 8"></i>
                                                            <i class="wl-icon-wenjuan content-tab-catalo-icon" v-if="name.CellType == 9"></i>
                                                            <i class="wl-icon-tiwen content-tab-catalo-icon" v-if="name.CellType == 10"></i>
                                                            <i class="wl-icon-tounaofengbao content-tab-catalo-icon" v-if="name.CellType == 11"></i>
                                                            <span v-if="NumType3 == '1'">{{
                                                                Level3.replace("\{\{index\}\}", index2 + 1)
                                                                    .replace("\{\{y\}\}", index1 + 1)
                                                                    .replace("\{\{x\}\}", index + 1)
                                                            }}</span>
                                                            <span v-if="NumType3 == '一'">{{ (index2 + 1) | priceFmt(Level3) }}</span> &nbsp;
                                                            <span v-html="name.CellName">{{ name.CellName }}</span>
                                                            <div class="content-tab-catalo-lists" v-if="name.CellType == 4">
                                                                <p v-for="(four, index) in name.fourCell" :key="index" @click="gobook(four.Id, four.CellType)">
                                                                    <i class="wl-icon-ziyuan content-tab-catalo-icon" v-if="four.cellType == 1"></i>
                                                                    <i class="wl-icon-lianjie1 content-tab-catalo-icon" v-if="four.cellType == 2"></i>
                                                                    <i class="wl-icon-tuwen1 content-tab-catalo-icon" v-if="four.cellType == 3"></i>
                                                                    <i class="wl-icon-wenjianjia1 content-tab-catalo-icon" v-if="four.cellType == 4"></i>
                                                                    <i class="wl-icon-ceyan1 content-tab-catalo-icon" v-if="four.cellType == 5"></i>
                                                                    <i class="wl-icon-zuoye_huaban content-tab-catalo-icon" v-if="four.cellType == 6"></i>
                                                                    <i class="wl-icon-toupiao content-tab-catalo-icon" v-if="four.cellType == 7"></i>
                                                                    <i class="wl-icon-taolun2 content-tab-catalo-icon" v-if="four.cellType == 8"></i>
                                                                    <i class="wl-icon-wenjuan content-tab-catalo-icon" v-if="four.cellType == 9"></i>
                                                                    <i class="wl-icon-tiwen content-tab-catalo-icon" v-if="four.cellType == 10"></i>
                                                                    <i class="wl-icon-tounaofengbao content-tab-catalo-icon" v-if="four.cellType == 11"></i>
                                                                    <span v-html="four.cellName">{{ four.cellName }}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="辅页" name="recommend">
                                <div class="ph-details-mulu" style="padding:10px;">
                                    <div class="clearfix" v-for="(item, index) in imgs" :key="index">
                                        <img :src="item.url" style="width:100%;" />
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="teaching-content-team fl">
                        <div class="teaching-content-principal">
                            <h3>作者</h3>
                            <div class="teaching-principal-nav clearfix" @click="enterTeaZone(principalData.id)">
                                <img :src="bookInfo.CreateUserCover || principalImg" alt class="principal-nav-img fl" />
                                <div class="principal-nav-name fl">
                                    <h5>{{ bookInfo.Author }}</h5>
                                    <!-- <p>{{principalData.degree}}</p> -->
                                </div>
                            </div>
                            <p class="principal-nav-title">简介：{{ bookInfo.Introduction }}</p>
                            <div class="teaching-principal-lis clearfix" v-for="(item, index) in listData1" :key="index">
                                <img :src="item.avatorUrl" alt class="principal-nav-img fl" @click="enterTeaZone(item.id)" />
                                <div class="principal-lis-name fl clearfix">
                                    <h5>{{ item.displayName }}</h5>
                                    <p :class="item.show ? title : titles">{{ item.remark }}</p>
                                    <!-- <i class="fr" :class="item.show?xiala:shouqi" @click="item.show = !item.show"></i> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 移动端 -->
        <div class="ph-teacher-details">
            <div class="crumbs-text">
                <div style="padding:0 20px;">
                    <i class="wl-icon-zhuye1"></i>
                    <span @click="goHome" style="cursor: pointer;">首页</span>
                    <span>></span>
                    <span @click="toMetarialCenter">教材中心</span>
                    <span>></span>
                    <span>教材详情</span>
                </div>
            </div>
            <div class="ph-teacher-details-content">
                <div class="ph-metarial-info-con clearfix">
                    <div class="ph-cover-con fl">
                        <img :src="bookInfo.BookCover || abstractImg" />
                    </div>
                    <div class="fl ph-met-detail-con">
                        <p class="p-met-title">{{ bookInfo.Title }}</p>
                        <p>定 价：￥{{ bookInfo.Price }}</p>
                        <p>作者：{{ bookInfo.Author }}</p>
                        <p>教材编号(ISBN)：{{ bookInfo.ISBN }}</p>
                        <p>发行日期：{{ bookInfo.IssueDate }}</p>
                        <p>出版社：{{ bookInfo.publishName }}</p>
                    </div>
                </div>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="目录" name="catalo">
                        <div class="ph-details-mulu">
                            <div class="ph-mulu-zhang" v-for="(item, index) in BookCatalogData" :key="index">
                                <div class="ph-mulu-name">
                                    <span v-if="NumType1 == '1'">{{ Level1.replace("\{\{index\}\}", index + 1) }}</span>
                                    <span v-if="NumType1 == '一'">{{ (index + 1) | priceFmt(Level1) }}</span>
                                    {{ item.name }}
                                </div>
                                <div class="ph-mulu-jiedian" v-for="(nav, index1) in item.topics" :key="index1">
                                    <div class="ph-icon-nav-name">
                                        <i class="wl-icon-dian"></i>
                                        <span v-if="NumType2 == '1'">{{ Level2.replace("\{\{index\}\}", index1 + 1).replace("\{\{x\}\}", index + 1) }}</span>
                                        <span v-if="NumType2 == '一'">{{ (index1 + 1) | priceFmt(Level2) }}</span>
                                        <span v-html="nav.name" class="span-jie">{{ nav.name }}</span>
                                    </div>
                                    <div v-for="(name, index2) in nav.cells" :key="index2" class="ph-mulu-name-title" @click="gobook(name.Id, name.CellType)">
                                        <i class="wl-icon-ziyuan content-tab-catalo-icon" v-if="name.CellType == 1"></i>
                                        <i class="wl-icon-lianjie1 content-tab-catalo-icon" v-if="name.CellType == 2"></i>
                                        <i class="wl-icon-tuwen1 content-tab-catalo-icon" v-if="name.CellType == 3"></i>
                                        <i class="wl-icon-wenjianjia1 content-tab-catalo-icon" v-if="name.CellType == 4"></i>
                                        <i class="wl-icon-ceyan1 content-tab-catalo-icon" v-if="name.CellType == 5"></i>
                                        <i class="wl-icon-zuoye_huaban content-tab-catalo-icon" v-if="name.CellType == 6"></i>
                                        <i class="wl-icon-toupiao content-tab-catalo-icon" v-if="name.CellType == 7"></i>
                                        <i class="wl-icon-taolun2 content-tab-catalo-icon" v-if="name.CellType == 8"></i>
                                        <i class="wl-icon-wenjuan content-tab-catalo-icon" v-if="name.CellType == 9"></i>
                                        <i class="wl-icon-tiwen content-tab-catalo-icon" v-if="name.CellType == 10"></i>
                                        <i class="wl-icon-tounaofengbao content-tab-catalo-icon" v-if="name.CellType == 11"></i>
                                        <span v-if="NumType3 == '1'">{{
                                            Level3.replace("\{\{index\}\}", index2 + 1)
                                                .replace("\{\{y\}\}", index1 + 1)
                                                .replace("\{\{x\}\}", index + 1)
                                        }}</span>
                                        <span v-if="NumType3 == '一'">{{ (index2 + 1) | priceFmt(Level3) }}</span> &nbsp;
                                        <span class="ph-name-icon" v-html="name.CellName">{{ name.CellName }}</span>
                                        <div class="ph-tab-catalo-lists" v-if="name.CellType == 4">
                                            <p v-for="(four, index) in name.fourCell" :key="index" @click="goBookDetail(four.Id, four.cellType)">
                                                <i class="wl-icon-ziyuan content-tab-catalo-icon" v-if="four.cellType == 1"></i>
                                                <i class="wl-icon-lianjie1 content-tab-catalo-icon" v-if="four.cellType == 2"></i>
                                                <i class="wl-icon-tuwen1 content-tab-catalo-icon" v-if="four.cellType == 3"></i>
                                                <i class="wl-icon-wenjianjia1 content-tab-catalo-icon" v-if="four.cellType == 4"></i>
                                                <i class="wl-icon-ceyan1 content-tab-catalo-icon" v-if="four.cellType == 5"></i>
                                                <i class="wl-icon-zuoye_huaban content-tab-catalo-icon" v-if="four.cellType == 6"></i>
                                                <i class="wl-icon-toupiao content-tab-catalo-icon" v-if="four.cellType == 7"></i>
                                                <i class="wl-icon-taolun2 content-tab-catalo-icon" v-if="four.cellType == 8"></i>
                                                <i class="wl-icon-wenjuan content-tab-catalo-icon" v-if="four.cellType == 9"></i>
                                                <i class="wl-icon-tiwen content-tab-catalo-icon" v-if="four.cellType == 10"></i>
                                                <i class="wl-icon-tounaofengbao content-tab-catalo-icon" v-if="four.cellType == 11"></i>
                                                <span class="span-disan" v-html="four.cellName">{{ four.cellName }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="辅页" name="recommend">
                        <div class="ph-details-mulu" style="padding:10px;">
                            <div class="clearfix" v-for="(item, index) in imgs" :key="index">
                                <img :src="item.url" style="width:100%;" />
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
export default {
    data() {
        return {
            imgs: [],
            value: "",
            size: 0,
            screenWidth: document.body.clientWidth,
            recommendImg: require("assets/images/one-book.png"),
            loginImg: require("assets/images/login.png"),
            abstractImg: require("assets/images/the-last-new-nodata-imag.png"),
            abstractImg1: require("assets/images/abstract1.png"),
            abstractImg2: require("assets/images/abstract2.png"),
            abstractImg3: require("assets/images/abstract3.png"),
            principalImg: require("assets/images/default_avatar3.png"),
            activeName: "catalo",
            xiala: "wl-icon-xiala",
            shouqi: "wl-icon-shouqi",
            itemshow: "wl-icon-xiala",
            title: "principal-lis-title",
            titles: "principal-lis-titles",
            cid: "",
            point: 0,
            options: "",
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            presentation: {
                zhenshu: "",
                xianxiu: "",
                cehngji: "",
                cankao: "",
                wenti: "",
            },

            principalData: {
                id: "",
                imgs: require("assets/images/default_avatar3.png"),
                name: "张小娴",
                degree: "教授",
                title:
                    "何静，男, 教授、高级经济师，全国商业职业教商科人才培养专家，广东高职教育管理类专业教学指导委员会委员，广东高职教育公共事业与管理分指委副主任委员，广东农工商职业技术学院教学指导委员会副主任委员，广东省对外服务贸易协会副会长；先后在企业、高职院校工作二十余年，公开发表论文40余篇，编著教材、专著13部，曾获“优秀教育工作者”、“ 优秀共产党员”、“ 优秀培训师”等荣誉，主要研究商业经济、职业教育、创新创业、文化与心理。",
            },
            //团队负责人
            listData: [
                {
                    avatorUrl: require("assets/images/default_avatar3.png"),
                    displayName: "何静",
                    remark: "何静，男, 教授、高级经济师，全国商业职业教商科,何静，男, 教授、高级经济师，全国商业职业教商科",
                },
            ],
            //助教
            listData1: [],
            //课程公告
            noticeData: [],
            coursewareList: [
                {
                    name: "知识经济新趋势和创新人才-微课.pfd",
                    type: 0,
                },
                {
                    name: "知识经济新趋势和创新人才-微课.mp4",
                    type: 1,
                },
                {
                    name: "知识经济新趋势和创新人才-微课.mp3",
                    type: 2,
                },
                {
                    name: "知识经济新趋势和创新人才-微课.png",
                    type: 3,
                },
            ],
            workList: [],
            cataloData: [],
            recommend: [],
            listFilter: [],
            shareLinkZone: "",
            shareLinkQq: "",
            shareCover: "",
            shareTitle: "",
            shareDesc: "",
            list: [],
            list1: [],
            show1: true,
            show2: false,
            arrowName: 0,
            bookInfo: [],
            BookCatalogData: [],
            schoolId: "",
            Level1: "第{{index}}章",
            Level2: "第{{index}}节",
            Level3: "第{{index}}讲",
            NumType1: "一",
            NumType2: "一",
            NumType3: "一",
        };
    },
    components: {
        QrcodeVue,
    },
    props: {
        bookId: {
            type: String,
            default: "",
        },
    },
    filters: {
        priceFmt(n, str) {
            if (!/(^[1-9]\d*$)/) {
                return "非法数字";
            }
            var nString = n.toString();
            var uppercase = "千百亿千百十万千百十个";
            var nLength = nString.length;
            var newStr = "";
            if (uppercase.length - nLength < 0) {
                return "数字过长";
            }
            uppercase = uppercase.substr(uppercase.length - nLength);
            for (var i = 0; i < nLength; i++) {
                newStr += "零一二三四五六七八九".charAt(nString[i]) + uppercase.charAt(i);
            }
            newStr = newStr.substr(0, newStr.length - 1);
            if (nLength < 3) {
                newStr = newStr.replace("一十", "十").replace("十零", "十");
            } else {
                newStr = newStr
                    .replace("十零", "十")
                    .replace("零千", "")
                    .replace("零百", "")
                    .replace("零十", "零");
            }
            return str.replace("{{index}}", newStr);
        },
    },
    created() {
        this.getShareLink();
        this.getBookInfo();
        this.getBookCatalogInfo();
        // this.getRecommendBookList();
        this.getValue();
        this.getBookCatalogConfig();
        this.getAttachedImg();
    },
    beforeCreate() {
        document.title = "";
    },
    methods: {
        goHome() {
            this.$router.push({
                name: "xIndex",
            });
        },
        toMetarialCenter() {
            this.$router.push({
                name: "metarialCenter",
            });
        },
        getAttachedImg() {
            var self = this;
            this.$http
                .post("/api/XOrg/TextBook/getAttachedImg", {
                    courseId: this.bookId,
                })
                .then((res) => {
                    if (res.code > 0) {
                        if (res.img) {
                            self.imgs = JSON.parse(res.img);
                        }
                    }
                });
        },
        //获取教材目录配置
        getBookCatalogConfig() {
            var self = this;
            this.$http
                .post("/api/XOrg/BookMaterialCatalog/getCoursewareCatalogConfig", {
                    courseId: this.bookId,
                })
                .then((res) => {
                    if (res.code > 0) {
                        self.Level1 = res.levelData.Level1Format;
                        self.NumType1 = res.levelData.Level1Num;
                        self.Level2 = res.levelData.Level2Format;
                        self.NumType2 = res.levelData.Level2Num;
                        self.Level3 = res.levelData.Level3Format;
                        self.NumType3 = res.levelData.Level3Num;
                    }
                });
        },
        gobook(Id, Type) {
            if (Type != 4) {
                this.$router.push({
                    name: "book",
                    params: {
                        resId: Id,
                    },
                });
            }
        },
        goBookDetail(Id, Type) {
            if (Type != 4) {
                this.$router.push({
                    name: "book",
                    params: {
                        resId: Id,
                    },
                });
            }
        },
        getValue() {
            this.value = "http://www.clppx.org.cn/wlx/studyCenter/metarialCenter/" + this.bookId;
            this.size = this.screenWidth * 0.065;
        },
        //获取教材目录
        getBookCatalogInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/TextBookDetails/getBookCatalogInfo", {
                    bookId: this.bookId,
                })
                .then((rst) => {
                    if (rst.code > 0) {
                        that.BookCatalogData = rst.list;
                        // $(".teaching-content-principal").height($(".teaching-content-tab").height());
                        // 俩边高度一致
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //获取教材详情
        getBookInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/TextBook/getBookInfo", {
                    bookId: this.bookId,
                })
                .then((rst) => {
                    if (rst.code > 0) {
                        that.bookInfo = rst.bookInfo;
                        if (window.innerWidth < 960) {
                            document.title = rst.bookInfo.Title;
                        } else {
                            document.title = "1+X试点";
                        }
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        toHome() {
            this.$router.push({
                name: "xHome",
            });
        },
        getBookCenter() {
            this.$router.push({
                name: "textBookCenter",
            });
        },
        handleClick(tab, event) {
            console.log(tab.paneName);
        },
        getItemShow() {
            if (this.itemshow == this.xiala) {
                this.itemshow = this.shouqi;
            } else {
                this.itemshow = this.xiala;
            }
        },
        //QQ QQ空间分享
        getShareLink() {
            // let cover = "你的分享图片";
            let cover = this.bookInfo.BookCover;
            // let title = "你的分享标题";
            let title = this.bookInfo.Title;

            // let desc  = "你的分享简述";
            let desc = this.bookInfo.TextBookBrief;
            let teaUrl = window.location.href;
            let teaShareLink = teaUrl;
            //QQ空间
            let newLink = "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey" + "?url=" + teaShareLink + "&sharesource=qzone" + "&title=" + title + "&pics=" + cover + "&summary=" + desc;
            //QQ
            let shareLinkQq = "http://connect.qq.com/widget/shareqq/index.html" + "?url=" + teaShareLink + "&sharesource=qzone" + "&title=" + title + "&pics=" + cover + "&summary=" + desc;
            //&title=你的分享标题
            //&pics=你的分享图片
            //=你的分享描述信息"
            //&desc=你的分享简述
            this.shareLinkZone = newLink;
            this.shareLinkQq = shareLinkQq;
        },
    },
};
</script>

<style lang="scss">
.ph-teacher-details {
    display: none;
}
@media only screen and (max-width: 960px) and (min-width: 320px) {
    .teaching-details-wrapper {
        display: none;
    }
    .teaching-details-content {
        background: rgba(242, 242, 242, 1);
        height: 100%;
        .el-tabs__item.is-active {
            font-size: 16px;
        }
        .crumbs-text {
            background: #f5f7fb;
            height: 40px;
            line-height: 40px;
            color: #666;
            span {
                margin: 0 3px;
            }
        }
        .ph-metarial-info-con {
            .ph-cover-con {
                height: 140px;
                width: 100px;
                overflow: hidden;
                img {
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                }
            }
            .ph-met-detail-con {
                margin-left: 10px;
                width: calc(100% - 110px);
                height: 140px;
                color: #333;
                font-size: 12px;
                .p-met-title {
                    font-weight: bold;
                }
                p {
                    margin-bottom: 4px;
                }
            }
        }
        .ph-teacher-details {
            display: block;
            background: rgba(242, 242, 242, 1);
            height: 100%;
            .ph-teacher-details-content {
                background: #f2f2f2;
                padding: 10px;
                overflow-x: hidden;
                overflow-y: scroll;
                box-sizing: border-box;
            }
            .ph-details-abstract-video {
                margin-top: 40px;
                width: 100%;
                .video-img-cover {
                    width: 100%;
                }
            }
            .ph-details-mulu {
                background: #fff;
                border-radius: 10px;
            }
            .ph-name-icon {
                font-size: 14px;
            }
            .ph-details-data-left {
                font-size: 14px;
                margin-top: 20px;
                min-height: 60px;
                // padding-left: 20px;
                p {
                    height: 25px;
                    line-height: 25px;
                    margin-bottom: 20px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }

            .ph-mulu-title {
                font-size: 16px;
                color: #5c9eff;
                margin-bottom: 20px;
                margin-top: 25px;
            }
            .ph-mulu-zhang {
                font-size: 20px;
                color: #333333;
            }
            .ph-mulu-name {
                padding-left: 20px;
                padding-top: 20px;
                font-size: 16px;
            }
            .ph-tab-catalo-lists {
                color: #333333;
                font-size: 28px;
                font-family: SourceHanSansSC-Regular;
                font-weight: 400;
            }
            .ph-mulu-jiedian {
                font-size: 16px;
                color: #333333;
                margin-left: 30px;
                padding-top: 20px;
                .span-jie {
                    font-size: 14px;
                    color: #333333;
                }
            }
            .ph-icon-nav-name {
                height: 40px;
                // padding:10px 0;
                line-height: 40px;
                font-size: 16px;
                font-family: SourceHanSansSC-Regular;
                font-weight: 400;
            }

            .ph-mulu-name-title {
                padding: 10px 0;
            }
            .ph-tab-catalo-lists:hover {
                background: rgba(255, 154, 160, 1);
                color: #fff;
            }

            .content-tab-catalo-icon {
                padding-right: 10px;
            }
            .span-disan {
                font-size: 14px;
            }
            .ph-tab-catalo-lists {
                padding-left: 27px;
                font-size: 16px;
                padding-top: 10px;
            }
        }
    }
}
</style>
